/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_HomeInputs */

const vi_media_owner_home = /** @type {(inputs: Media_Owner_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ`)
};

/**

* @param {Media_Owner_HomeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_home = /** @type {((inputs?: Media_Owner_HomeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_HomeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_home(inputs)
});